import ColorPicker from 'library/components/form/color-picker';
import withFormContainer from 'library/components/modal/hocs/with-form-container';

export default withFormContainer(ColorPicker);
